var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgReadingList = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 27,
  height: 22,
  viewBox: "0 0 27 22"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "nonzero",
  d: "M26.88 12.686v3.358a5.596 5.596 0 0 1-3.132 5.022 5.603 5.603 0 0 1-5.892-.595 5.594 5.594 0 0 1-2.063-5.547h-4.706a5.594 5.594 0 0 1-2.063 5.548 5.603 5.603 0 0 1-5.893.595A5.596 5.596 0 0 1 0 16.044v-3.358c0-.101.027-.2.08-.287L6.8.647a.56.56 0 1 1 .96.575L1.35 12.437a5.569 5.569 0 0 1 9.377 1.368h5.426a5.566 5.566 0 0 1 9.376-1.368l-6.41-11.215a.56.56 0 0 1 .961-.575l6.72 11.752c.053.086.08.186.08.287Z"
})));
export default SvgReadingList;